import { render, staticRenderFns } from "./DropdownCustomOpener.vue?vue&type=template&id=23b15d08&scoped=true&"
import script from "./DropdownCustomOpener.vue?vue&type=script&lang=js&"
export * from "./DropdownCustomOpener.vue?vue&type=script&lang=js&"
import style0 from "./DropdownCustomOpener.vue?vue&type=style&index=0&id=23b15d08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b15d08",
  null
  
)

export default component.exports